import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { images } from '../../lib/config';
import './Header.css';

const Header = ({ onNavigationClick }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'HOME' },
    { path: '/application', label: 'APPLICATION' },
    { path: '/blog', label: 'BLOG' },
    { path: '/about', label: 'ABOUT US' },
    { path: '/contact', label: 'CONTACT US' },
    { path: '/template', label: 'TEMPLATE' }
  ];

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const handleNavClick = (e) => {
    if (onNavigationClick) {
      onNavigationClick();
    }
    closeDrawer();
  };

  // Prevent body scroll when drawer is open
  useEffect(() => {
    if (isDrawerOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isDrawerOpen]);

  // Close drawer on route change
  useEffect(() => {
    closeDrawer();
  }, [location.pathname]);

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <header className="header header-container-main">
      <div className='container'>
        <div className="header-container">
          {/* Logo Section */}
          <Link to="/" className="header-logo" onClick={handleNavClick}>
            <img src={images.ledIcon1} alt="LED Scroller Logo" className="logo-image" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="header-nav-desktop">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`nav-link ${isActive(link.path) ? 'active' : ''}`}
                onClick={handleNavClick}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Mobile Hamburger Button */}
          <button
            className={`hamburger-button ${isDrawerOpen ? 'open' : ''}`}
            onClick={toggleDrawer}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>

      {/* Mobile Drawer */}
      <div className={`drawer-overlay ${isDrawerOpen ? 'open' : ''}`} onClick={closeDrawer}></div>
      <div className={`drawer ${isDrawerOpen ? 'open' : ''}`}>
        <div className="drawer-header">
          <Link to="/" className="drawer-logo" onClick={handleNavClick}>
            <img src={images.ledIcon1} alt="LED Scroller Logo" className="logo-image" />
          </Link>
          <button className="drawer-close" onClick={closeDrawer} aria-label="Close menu">
            <span>&times;</span>
          </button>
        </div>
        <nav className="drawer-nav">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`drawer-link ${isActive(link.path) ? 'active' : ''}`}
              onClick={handleNavClick}
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Header;

